import React from "react";

import CreateNewProjectPaneView from "src/app/modals/CreateNewProjectPane/CreateNewProjectPaneView";
import ProjectBriefPreview from "../../components/ProjectBriefPreview";

interface ActivateResearchProjectPaneProps {
  onClose: () => void;
  projectId: string;
}

export default function ActivateResearchProjectPane({
  onClose,
  projectId,
}: ActivateResearchProjectPaneProps) {
  return (
    <CreateNewProjectPaneView
      onClose={onClose}
      action="activate"
      projectId={projectId}
      briefPreview={<ProjectBriefPreview />}
    />
  );
}
